import { generic_get_network_request } from '../axiosClient/axiosClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface User_Info_Type {
  company_id: number;
  company_name: string;
  user_id: number;
  email_id: string;
  first_name: string;
  last_name: string;
  profile_avatar: string;
  mh_access_type: string;
  has_consented: boolean;
  is_active: boolean;
}

export interface Company_Info_Type {
  company_id: number;
  company_name: string;
  current_user_count: number;
  is_primary: boolean;
  is_client: boolean;
  user_info: User_Info_Type[];
}

// ─── API Functions ────────────────────────────────────────────────────────────

export interface GetUsersByCompany_API_Response_Type {
  data: Company_Info_Type[];
}

export const getUsersByCompany = (api_endpoint: string) => {
  return generic_get_network_request<GetUsersByCompany_API_Response_Type>(api_endpoint);
};